import { React, useState } from "react";

import { useSelectedVehicle } from "../context/vehicle.context";

export const useTestOp = () => {
    const { selVehData, setSelVehData } = useSelectedVehicle();

    const setKill = (killType, setValue) => {
        setSelVehData({
            ...selVehData,
            kills: {
                ...selVehData.kills,
                [killType]: setValue
            }
        });
    }

    const testMobilityKill = () => {
        console.log("Mobility Kill Test Triggered");
        setKill('mobility', true);
    }
    const resetMobilityKill = () => {
        console.log("Mobility Kill Reset Triggered");
        setKill('mobility', false);
    }
    const testWeaponKill = () => {
        console.log("Weapon Kill Test Triggered");
        setKill('weapon', true);
    }
    const resetWeaponKill = () => {
        console.log("Weapon Kill Reset Triggered");
        setKill('weapon', false);
    }
    const testCommsKill = () => {
        console.log("Comms Kill Test Triggered");
        setKill('comms', true);
    }
    const resetCommsKill = () => {
        console.log("Comms Kill Reset Triggered");
        setKill('comms', false);
    }

    const testTotalKill = () => {
        console.log("Total Kill Test Triggered");
        setKill('total', true);
    }
    const resetTotalKill = () => {
        console.log("Total Kill Reset Triggered");
        setKill('total', false);
    }

    return {
        testMobilityKill,
        testWeaponKill,
        testCommsKill,
        testTotalKill,
        resetMobilityKill,
        resetWeaponKill,
        resetCommsKill,
        resetTotalKill,
    }
}